$(document).ready(function () {
  if ($(window).width() < 749) {
    $(document).on("click", ".sidebar_grid .menu h3", function () {
      $(this).closest(".menu").find(".sidebar-lists").slideToggle();
      $(this).toggleClass("active");
    });
  }
  var maxDate = year + "-" + month + "-" + day;
  $("#start").attr("min", maxDate);
  var dtToday = new Date();
  var month = dtToday.getMonth() + 1;
  var day = dtToday.getDate();
  var year = dtToday.getFullYear();
  if (month < 10) month = "0" + month.toString();
  if (day < 10) day = "0" + day.toString();
  var maxDate = year + "-" + month + "-" + day;
  $("#start").attr("min", maxDate);
  $(document).on("change", "#start", function () {
    var dateSelected = $(this).val();
    $("#dataSelected").val(dateSelected);
  });
  $(document).on("click", ".text--faq", function () {
    var dataid = $(this).attr("data-linked-id");
    $("html,body").animate({ scrollTop: $(dataid).offset().top }, "slow");
  });

  let closeTimer;

  $(document).on("mouseenter", ".megemenu_custom", function () {
    // Cancel any scheduled closes
    clearTimeout(closeTimer);

    // Close other open menus first
    $("details.mega-menu").prop("open", false);

    // Open the one we're hovering
    $(this).find("details.mega-menu").prop("open", true);
  });

  $(document).on("mouseleave", ".megemenu_custom", function () {
    const $menu = $(this).find("details.mega-menu");

    // Schedule close with a delay
    closeTimer = setTimeout(() => {
      $menu.prop("open", false);
    }, 200); // adjust delay to taste
  });
});
